<div class="pdf-dialog">
  <div>
    <mat-progress-bar mode="indeterminate" aria-label="Typesetting PDF"></mat-progress-bar>
    <div class="loading-note">Downloading prepared {{ data.exportType }}, please wait a moment</div>
  </div>
</div>
